require('./bootstrap');

require('alpinejs');

import $ from 'jquery';
window.$ = $;
window.jQuery = $;

require('./own/own');

import IMask from 'imask';
/**
 * Flatpickr
 */
import flatpickr from "flatpickr";

require("flatpickr/dist/themes/airbnb.css");

flatpickr.setDefaults({
    allowInput: true,
    altInput: true,
    altFormat: 'Y-m-d',
    dateFormat: 'Y-m-d',
    theme: 'airbnb',
    locale: {
        firstDayOfWeek: 1,
    },
})

$(function () {
    new flatpickr($('.is-date'));
});

import {addSelect2} from "./own/select2";
